<template>
  <v-card outlined class="rounded-lg">
    <span v-if="showTitle">
      <v-card-title v-if="['Aktivitas', 'AHV-Vorstand', 'HBV-Vorstand'].includes(vorstand)"
        >Chargen {{ vorstand }}</v-card-title
      >
      <v-card-title v-else>{{ vorstand }}</v-card-title>
    </span>
    <v-list
      v-if="['Aktivitas', 'AHV-Vorstand', 'HBV-Vorstand', 'Ripuarentage'].includes(vorstand)"
      nav
      dense
      class="py-0"
    >
      <v-list-item
        link
        v-for="(item, key, index) in chargen"
        :key="index"
        @click="(showKontakt = true) && (bbr = item)"
      >
        <v-list-item-content class="pl-2">
          <v-list-item-title class="font-weight-normal">{{ key }}</v-list-item-title>
          <v-list-item-subtitle class="font-weight-bold">{{ item.vorname }} {{ item.nachname }}</v-list-item-subtitle>
          <v-list-item-subtitle>{{ item.handy }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action class="text-center">
          <v-btn icon :href="`mailto:` + item.chargenmail"><v-icon>mail</v-icon></v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-list v-else nav dense class="py-0">
      <v-list-item link v-for="(item, key, index) in chargen" :key="index">
        <v-list-item-content class="pl-2">
          <v-list-item-title class="font-weight-normal">{{ item.titel }}</v-list-item-title>
          <v-list-item-subtitle class="font-weight-bold" v-for="item2 in item.berechtigt" :key="bbr">
            <v-chip small label class="grey lighten-4" @click="showBbr(item2)">
              {{ $filters.user(item2, bbrbbr) }}
            </v-chip>
          </v-list-item-subtitle>
          <v-list-item-subtitle>{{ item.handy }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <dialogKontakt :visible.sync="showKontakt" :bbr="bbr" @close="showKontakt = false"></dialogKontakt>
  </v-card>
</template>

<script>
  export default {
    props: ["vorstand", "kontaktbbr", "showTitle"],
    data() {
      return {
        showKontakt: false,
        bbr: "false",
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      chargen() {
        let items;
        if (this.$store.state.einstellungen.einstellungen.length > 0) {
          items = this.$store.getters["einstellungen/einstellung"]("rollen").seiten;
        }
        let chargen = {};
        if (items) {
          if (this.vorstand === "Aktivitas") {
            chargen.Senior = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "Senior").berechtigt[0]
            );
            chargen.Senior.chargenmail = "x@kdstv-ripuaria.de";
            chargen.Consenior = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "Consenior").berechtigt[0]
            );
            chargen.Consenior.chargenmail = "xx@kdstv-ripuaria.de";
            chargen.Fuxmajor = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "Fuxmajor").berechtigt[0]
            );
            chargen.Fuxmajor.chargenmail = "fm@kdstv-ripuaria.de";
            chargen.Schriftführer = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "Schriftführer").berechtigt[0]
            );
            chargen.Schriftführer.chargenmail = "xxx@kdstv-ripuaria.de";
            chargen.Kassierer = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "Kassierer").berechtigt[0]
            );
            chargen.Kassierer.chargenmail = "xxxx@kdstv-ripuaria.de";
          }
          if (this.vorstand === "AHV-Vorstand") {
            chargen.Senior = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "Philistersenior").berechtigt[0]
            );
            chargen.Senior.chargenmail = chargen.Senior.email;
            chargen.Consenior = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "Philisterconsenior").berechtigt[0]
            );
            chargen.Consenior.chargenmail = chargen.Consenior.email;
            chargen.Schriftführer = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "Philisterschriftführer").berechtigt[0]
            );
            chargen.Schriftführer.chargenmail = chargen.Schriftführer.email;
            chargen.Kassierer = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "Philisterkassierer").berechtigt[0]
            );
            chargen.Kassierer.chargenmail = chargen.Kassierer.email;
          }
          if (this.vorstand === "HBV-Vorstand") {
            chargen.Vorsitzender = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "HBV Vorsitzender").berechtigt[0]
            );
            chargen.Vorsitzender.chargenmail = chargen.Vorsitzender.email;
            chargen["Stv. Vorsitzender"] = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "HBV Stv. Vorsitzender").berechtigt[0]
            );
            chargen["Stv. Vorsitzender"].chargenmail = chargen["Stv. Vorsitzender"].email;
            chargen.Schriftführer = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "HBV Schriftführer").berechtigt[0]
            );
            chargen.Schriftführer.chargenmail = chargen.Schriftführer.email;
            chargen.Kassierer = this.$store.getters["bbrbbr/bbr"](
              items.find((item) => item.titel === "HBV Kassierer").berechtigt[0]
            );
            chargen.Kassierer.chargenmail = chargen.Kassierer.email;
          }
          if (this.vorstand === "Ämter") {
            chargen = items.filter((item) => item.gruppe === this.vorstand);
          }
          if (this.vorstand === "Kommissionen") {
            chargen = items.filter((item) => item.gruppe === this.vorstand);
          }
          if (this.vorstand === "Zirkel") {
            chargen = items.filter((item) => item.gruppe === this.vorstand);
          }
          if (this.vorstand === "Ripuarentage") {
            chargen.Organisation = this.bbrbbr.find((item) => item.email === "stephan.buecker@t-online.de");
            chargen.Organisation.chargenmail = chargen.Organisation.email;
          }
        }
        return chargen;
      },
    },
    methods: {
      showBbr(bbr) {
        this.bbr = this.$store.getters["bbrbbr/bbr"](bbr);
        this.showKontakt = true;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// chargen.vue?75a05c8e